export const SET_FILE = 'SET_FILE'
export const SET_STEP = 'SET_STEP'
export const SELECT_CARD = 'SELECT_CARD'
export const SELECT_PACKAGE = 'SELECT_PACKAGE'
export const SELECT_PLATFORM = 'SELECT_PLATFORM'
export const SELECT_STRATEGY = 'SELECT_STRATEGY'
export const SELECT_VISUAL_TYPE = 'SELECT_VISUAL_TYPE'
export const CAMPAIGN_NAME = 'CAMPAIGN_NAME'
export const TITLE = 'TITLE'
export const HYPERLINK = 'HYPERLINK'
export const DESCRIPTION = 'DESCRIPTION'
export const AUDIENCE = 'AUDIENCE'
export const REFRESH_AUDIENCE = 'REFRESH_AUDIENCE'
export const ADD_LOCATION = 'ADD_LOCATION'
export const LOCATIONS = 'LOCATIONS'
export const START_DATE = 'NEW_CAMP_START_DATE'
export const END_DATE = 'NEW_CAMP_END_DATE'
export const SET_BUDGET = 'SET_BUDGET'
export const RESET_CAMPAIGN = 'RESET_CAMPAIGN'
export const SET_TV_CHANNELS = 'SET_TV_CHANNELS'
export const SET_MOVIES = 'SET_MOVIES'
export const SET_TV_SEIRES = 'SET_TV_SEIRES'
export const RESET_PLACEMENTS = 'RESET_PLACEMENTS'
export const SET_CAMPAIGN_PRICE = 'SET_CAMPAIGN_PRICE'
export const SET_LAST_STEP = 'SET_LAST_STEP'
export const UPDATE_LOCATION = 'UPDATE_LOCATION'
export const SET_BRAND = 'SET_BRAND'
export const ADD_CATEGORIES = 'ADD_CATEGORIES'

export const setFile = payload => dispatch =>
  dispatch({
    type: SET_FILE,
    payload: payload
  })
export const setCampaignPrice = payload => dispatch =>
  dispatch({
    type: SET_CAMPAIGN_PRICE,
    payload: payload
  })
export const setStep = payload => dispatch =>
  dispatch({
    type: SET_STEP,
    payload: payload
  })
export const setLastStep = payload => dispatch =>
  dispatch({
    type: SET_LAST_STEP,
    payload: payload
  })

export const selectCard = payload => dispatch =>
  dispatch({
    type: SELECT_CARD,
    payload: payload
  })

export const selectPackage = payload => dispatch =>
  dispatch({
    type: SELECT_PACKAGE,
    payload: payload
  })

export const selectPlatform = payload => dispatch =>
  dispatch({
    type: SELECT_PLATFORM,
    payload: payload
  })

export const selectStrategy = payload => dispatch =>
  dispatch({
    type: SELECT_STRATEGY,
    payload: payload
  })
export const selectVisualType = payload => dispatch =>
  dispatch({
    type: SELECT_VISUAL_TYPE,
    payload: payload
  })
export const campaignName = payload => dispatch =>
  dispatch({
    type: CAMPAIGN_NAME,
    payload: payload
  })
export const setTVChannels = payload => dispatch =>
  dispatch({
    type: SET_TV_CHANNELS,
    payload: payload
  })
export const setMovies = payload => dispatch =>
  dispatch({
    type: SET_MOVIES,
    payload: payload
  })
export const setTVSeries = payload => dispatch =>
  dispatch({
    type: SET_TV_SEIRES,
    payload: payload
  })
export const setTitle = payload => dispatch =>
  dispatch({
    type: TITLE,
    payload: payload
  })
export const setHyperlink = payload => dispatch =>
  dispatch({
    type: HYPERLINK,
    payload: payload
  })
export const setDescription = payload => dispatch =>
  dispatch({
    type: DESCRIPTION,
    payload: payload
  })
export const setAudience = payload => dispatch =>
  dispatch({
    type: AUDIENCE,
    payload: payload
  })
export const setRefreshAudience = () => dispatch =>
  dispatch({
    type: REFRESH_AUDIENCE
  })
export const addLocation = payload => dispatch =>
  dispatch({
    type: ADD_LOCATION,
    payload: payload
  })
export const setLocations = payload => dispatch =>
  dispatch({
    type: LOCATIONS,
    payload: payload
  })
export const setStartDate = payload => dispatch =>
  dispatch({
    type: START_DATE,
    payload: payload
  })
export const setEndDate = payload => dispatch =>
  dispatch({
    type: END_DATE,
    payload: payload
  })
export const setBudget = payload => dispatch =>
  dispatch({
    type: SET_BUDGET,
    payload: payload
  })
export const resetNewCampaign = payload => dispatch =>
  dispatch({
    type: RESET_CAMPAIGN,
    payload: payload
  })
export const resetPlacements = payload => dispatch =>
  dispatch({
    type: RESET_PLACEMENTS,
    payload: payload
  })
export const updateLocation = payload => dispatch =>
  dispatch({
    type: UPDATE_LOCATION,
    payload: payload
  })
export const setBrand = payload => dispatch =>
  dispatch({
    type: SET_BRAND,
    payload: payload
  })
export const addCategories = payload => dispatch =>
  dispatch({
    type: 'ADD_CATEGORIES',
    payload
  })
